import styled from 'styled-components';

import { media } from '~src/styles/media-templates';

export const QuestionsWrapper = styled.span`
  ${media.phone`
    width: 100%;
    height: auto;
    align-items: center;
    display: flex;
    justify-content: center;
    flex-grow: 1;
  `}
`;

export const Centering = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40vh;
`;

export const QuestionsGrid = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (min-height: 833px) {
    margin-top: 70px;
  }

  align-items: center;
  justify-content: center;
  max-width: ${({ theme }) => theme.sz.pageContentWidth};
  margin: 0 auto;
  ${media.phone`
    width: 100%;
    padding: 10px;
    height: auto;
  `}
`;

export const MobileAnon = styled.span`
  display: none;
  margin-bottom: 11px;
  ${media.phone`
    display: block;
  `}
`;
